export default __webpack_public_path__ + "static/media/mail_icon_white.93930f9e.svg";